import * as React from "react"

export const SearchBarWrapper: React.StatelessComponent<{}> = props => {
  return (
    <section className="search-bar container--lg align--center">
      <div className="search-bar__wrapper">
        {props.children}
      </div>
    </section>
  )
}

{/* TH: Added to styleguide! */}

